import { batch } from 'react-redux';

import { ActionService, ReduxService } from 'dashboard-services/services';
import { globalActions, loginActions } from 'primary-components';

import { basicPipelineCreatorActions } from 'actions/modules/datascience';
import { saveDialogPipelineCreatorActions } from 'actions/modules/datascience/creator';
import { routing } from 'routing';

import { Point } from '@projectstorm/geometry';

export default (() => {
  const ON_CHANGE = 'ON_CHANGE_BUILDER_CREATOR_DATA_SCIENCE'
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')

  const getTask = node => {
    let task = ReduxService.updateObject(node.getTask(), {})
    const nodeId = node.getId();
    const newParams = (task.params || []).map(p => ReduxService.updateObject(p, { value: p.value !== undefined && p.value !== "" ? p.value : (p.defaultValue || "") }))
    task = Object.assign({}, task, { params: newParams }) 
    return { task, nodeId };
  }
  
  const addTask = node => dispatch => {
    const { nodeId, task } = getTask(node)
    dispatch(addTaskReducer(task, nodeId));
  };

  const addTasks = (nodes = []) => dispatch => {
    const tasks = {}
    nodes.forEach(node => {
      const { nodeId, task } = getTask(node)
      tasks[nodeId] = task;
    })
    batch(() => {
      dispatch(onChange(tasks, 'tasks'))
      dispatch(onChange(tasks, 'initTasks'))
    })
  }

  const ADD_TASK = "ADD_TASK_CREATOR_DATA_SCIENCE";
  const addTaskReducer = ActionService.makeActionCreator(ADD_TASK, "task", "nodeId");

  const REMOVE_TASK = "REMOVE_TASK_CREATOR_DATA_SCIENCE";
  const removeTask = nodeId => (dispatch, getState) => {
    const builderState = getState().datascienceState.creatorState.builderState
    const links = builderState.links.filter(link => link.input.task === nodeId || link.output.task)
    const task = builderState.tasks[nodeId]
    const position = builderState.positions[nodeId]
    if(task) {
      dispatch(setTaskForRedo({ task, links, position, nodeId }))
      dispatch(removeTaskReducer(nodeId))
    }
  }
  const removeTaskReducer =  ActionService.makeActionCreator(REMOVE_TASK, "nodeId");

  const SET_TASK_FOR_REDO = "SET_TASK_FOR_REDO_CREATOR_DATA_SCIENCE"
  const setTaskForRedo = ActionService.makeActionCreator(SET_TASK_FOR_REDO, "task")

  const SELECT_TASKS = "SELECT_TASKS_CREATOR_DATA_SCIENCE"
  const selectTasks = ActionService.makeActionCreator(SELECT_TASKS, "tasks")

  const DOUBLE_CLICK_TASK = 'DOUBLE_CLICK_TASK_DATA_SCIENCE'
  const setDoubleClickTask = ActionService.makeActionCreator(DOUBLE_CLICK_TASK, 'nodeId')

  const connectTasks = (outputParamName, outputParamTask, inputParamName, inputParamTask, id) => dispatch => {
    const link = {
      value: basicPipelineCreatorActions.generateDynamicId(),
      id,
      output: {
        name: outputParamName,
        task: outputParamTask
      },
      input: {
        name: inputParamName,
        task: inputParamTask
      }
    }
    dispatch(connectTasksReducer(link))
  }

  const setLinks = (links = []) => dispatch => {
    batch(() => {
      dispatch(onChange(links, 'links'))
      dispatch(onChange(links, 'initLinks'))
    })
  }

  const CONNECT_TASKS = 'CONNECT_TASKS_CREATOR_DATA_SCIENCE'
  const connectTasksReducer = ActionService.makeActionCreator(CONNECT_TASKS, 'link')

  const DISCONNECT_TASKS = 'DISCONNECT_TASKS_CREATOR_DATA_SCIENCE'
  const disconnectTasks = ActionService.makeActionCreator(DISCONNECT_TASKS, 'id')

  const ADD_CONNECTIONS = 'ADD_CONNECTIONS_CREATOR_DATA_SCIENCE'
  const addConnections = ActionService.makeActionCreator(ADD_CONNECTIONS, 'links')

  const CHANGE_POSITION = 'CHANGE_POSITION_CREATOR_DATA_SCIENCE'
  const changePosition = ActionService.makeActionCreator(CHANGE_POSITION, 'nodeId', 'position')

  const CHANGE_POSITIONS = 'CHANGE_POSITIONS_CREATOR_DATA_SCIENCE'
  const changePositions = ActionService.makeActionCreator(CHANGE_POSITION, 'positions')

  const CHANGE_TASK_PROP = 'CHANGE_TASK_PROP_CREATOR_DATA_SCIENCE'
  const changeTaskProp = ActionService.makeActionCreator(CHANGE_TASK_PROP, 'nodeId', 'value', 'name')

  const changeSelectedTaskProp = (value, name) => (dispatch, getState) => {
    const builderState = getState().datascienceState.creatorState.builderState
    dispatch(changeTaskProp(builderState.doubleClickedTask, value, name))
  }

  const CHANGE_TASK = 'CHANGE_TASK'
  const changeTask = ActionService.makeActionCreator(CHANGE_TASK, 'nodeId', 'task')

  const CHANGE_TASK_PARAM = 'CHANGE_TASK_PARAM_CREATOR_DATA_SCIENCE'
  const changeSelectedTaskParam = (value, name) => (dispatch, getState) => {
    const builderState = getState().datascienceState.creatorState.builderState
    dispatch(changeTaskParam(builderState.doubleClickedTask, value, name))
  }

  const changeTaskParam = ActionService.makeActionCreator(CHANGE_TASK_PARAM, 'nodeId', 'value', 'name')

  const CHANGE_MARKDOWN = 'CHANGE_MARKDOWN_CREATOR_DATA_SCIENCE'
  const changeMarkdown = ActionService.makeActionCreator(CHANGE_MARKDOWN, 'value')

  const ADD_COMMENT = 'ADD_COMMENT_CREATOR_DATA_SCIENCE'
  const addComment = ActionService.makeActionCreator(ADD_COMMENT, 'id', 'position', 'userName')

  const SET_COMMENTS = 'SET_COMMENTS_CREATOR_DATA_SCIENCE'
  const setComments = ActionService.makeActionCreator(SET_COMMENTS, 'comments')

  const CHANGE_COMMENT = 'CHANGE_COMMENT_CREATOR_DATA_SCIENCE'
  const changeComment = ActionService.makeActionCreator(CHANGE_COMMENT, 'value', 'name', 'id')

  const REMOVE_COMMENT = 'REMOVE_COMMENT_CREATOR_DATA_SCIENCE'
  const removeComment = ActionService.makeActionCreator(REMOVE_COMMENT, 'id')

  const SET_ACTIVE_PORT = 'SET_ACTIVE_PORT_CREATOR_DATA_SCIENCE'
  const setActivePort = ActionService.makeActionCreator(SET_ACTIVE_PORT, 'input', 'activeType', 'id')

  const CLEAR_FOOTER_SELECTION = 'CLEAR_FOOTER_SELECTION_CREATOR_DATA_SCIENCE'
  const clearFooterSelection = ActionService.makeActionCreator(CLEAR_FOOTER_SELECTION)

  const SAVE_TEMP_TITLE = 'SAVE_TEMP_TITLE_CREATOR_DATA_SCIENCE'
  const saveTempTitle = ActionService.makeActionCreator(SAVE_TEMP_TITLE, 'nodeId')


  const play = ({ navigate, runPipelineCall, createPipelineCall, updatePipelineCall }) => (dispatch, getState) => {
    const hasWriteAccessTo = dispatch(loginActions.hasAccessTo(routing.dataScience.routing.creator.name, "W", routing.dataScience.name)),
          { saved, id, executing } = getState().datascienceState.creatorState.basicState,
          hasWarehouseAccess = getState().datascienceState.creatorState.builderState.hasWarehouseAccess,
          shouldHaveWarehouseAccess = getState().datascienceState.creatorState.builderState.shouldHaveWarehouseAccess,
          isBlockedByWarehouse = hasWarehouseAccess === false && shouldHaveWarehouseAccess === true,
          tasks = getState().datascienceState.creatorState.builderState.tasks || {},
          { name: pipelineName, groupName: pipelineGroupName } = getState().datascienceState.creatorState.saveDialogState
    if(executing || !hasWriteAccessTo || !id || basicPipelineCreatorActions.hasAccessProblems(tasks) || isBlockedByWarehouse) {
      return;
    }
    const execute = localId => batch(() => {
      dispatch(basicPipelineCreatorActions.setCommentsVisible(false))
      dispatch(basicPipelineCreatorActions.onChange([], "dynamicParameters"))
      dispatch(selectTasks(undefined))
      const id = localId || getState().datascienceState.creatorState.basicState.id
      return runPipelineCall({ pipelineId: id })
        .then(response => {
          navigate(window.location.pathname + "?jobId=" + (response?.jobId || ""))
          dispatch(basicPipelineCreatorActions.setExecuting(true))
          return response?.jobId
        })
        .then(jobId => {
          dispatch(globalActions.getMessageStore()).success("Your pipeline is running.")
          return jobId
        })
    })
    if(saved) {
      return execute()
    } else {
      dispatch(globalActions.getToastsStore()).info(
        "There are some unsaved changes. To run the pipeline it needs to be saved first.",
        "Pipeline not saved",
        {
          withCancel: false,
          confirmText: "Save and run",
          confirmAction: () => {
            if(pipelineName && pipelineGroupName) {
              dispatch(saveDialogPipelineCreatorActions.savePipeline({ navigate, createPipelineCall, updatePipelineCall })).then(response => execute(response.pipelineId)) // we need to pass the id, as it is already changed)
            } else {
              batch(() => {
                dispatch(saveDialogPipelineCreatorActions.onChange("Save pipeline", "title"))
                dispatch(saveDialogPipelineCreatorActions.onChange(true, "isOpen"))
                dispatch(saveDialogPipelineCreatorActions.onChange(execute, "onSubmit"))
              })
            }
          }
        }
      );
    }
  }

  const continuePipeline = continuePipelineCall => (dispatch, getState) =>
    continuePipelineCall({ payload: {
        userName: getState().myAccountState.settingsState.userName, 
        changes: (getState().datascienceState.creatorState.basicState.pausedEditedFiles || []).map(p => ({
          action: "FILE_EDIT",
          payload: p
        }))
      } })
      .then(() => {
        dispatch(basicPipelineCreatorActions.setPaused(false))
        dispatch(basicPipelineCreatorActions.setPausedEditedFiles([]))
      })

  const stop = ({ stopCall }) => (dispatch, getState) => {
    const executing = getState().datascienceState.creatorState.basicState.executing
    if(!executing) {
      return;
    }
    dispatch(globalActions.getToastsStore()).info(
      "Are you sure you want to stop the running pipeline? Your progress will not be saved.",
      "Stop pipeline",
      {
        withCancel: false,
        confirmText: "Stop",
        confirmAction: () => 
          stopCall()
            .then(() => dispatch(basicPipelineCreatorActions.setExecuting(false)))
            .then(() => dispatch(basicPipelineCreatorActions.setPaused(false)))
      }
    );
  }

  const inputIsNotConnected = (nL, globalLinks, node) => !globalLinks.find(g => g.input.task === nL.input.task && g.input.name === nL.input.name && nL.output.task === node.options.id)
  const linkDoesNotExist = (nL, globalLinks) => !globalLinks.find(gL => gL.value === nL.value)
  const getDiagramLink = (node, pL, nodes) => {
    const inputNode = node.options.id === pL.input.task ? node : nodes.find(node => node.options.id === pL.input.task),
          portInput = inputNode.ports[pL.input.name]

    const outputNode = node.options.id === pL.output.task ? node : nodes.find(node => node.options.id === pL.output.task), 
          portOutput = outputNode.ports[pL.output.name],
          link = portOutput.link(portInput)
    return link;
  }

  const undo = (getNode, forceUpdate, diagram) => (dispatch, getState) => {
    const { backupTasks, links: globalLinks } = getState().datascienceState.creatorState.builderState,
          category = getState().datascienceState.creatorState.basicState.categories.find(c => c.name === backupTasks[backupTasks.length - 1]?.task?.category)
    if(backupTasks.length === 0) {
      return;
    }
    const backupTask = backupTasks[backupTasks.length - 1]
    const node = getNode(new Point(backupTask.position.x, backupTask.position.y), backupTask.task, category, backupTask.nodeId)
    diagram.addNode(node)
    forceUpdate() // repaint the canvas
    dispatch(addTask(node))
    dispatch(onChange(backupTasks.slice(0, backupTasks.length - 1), 'backupTasks')) // clean redo task
    const nodes = diagram.getActiveModel().getNodes()
    const diagramLinks = []
    const newLinks = 
      backupTask.links
        .filter(nL => inputIsNotConnected(nL, globalLinks, node))
        .filter(nL => linkDoesNotExist(nL, globalLinks))
        .map(pL => {
          const link = getDiagramLink(node, pL, nodes)
          diagramLinks.push(link)
          return ReduxService.updateObject(pL, { id: link.options.id }) // we want to set the id
        })
    dispatch(addConnections(newLinks))
    diagram.getActiveModel().addAll(...diagramLinks)
    forceUpdate() // repaint the canvas
    Promise.resolve().then(() => {
      diagram.getDiagramEngine().repaintCanvas()
    })
  }

  const parseTriggeredBy = string => {
    if(string.includes("@")) {
      return string;
    }
    if(string === "FILEARRIVAL") {
      return "File arrival trigger"
    }
    return String(string).toLowerCase().capitaliseFirstLetter() + " trigger"
  }

  const getLastRunBy = componentStatus => {
      const match = componentStatus?.message.match("(Started by|\\\"TRIGGERED_BY\\\")\\s*:\\\"?(.*?(?=\\\",|$))")
      if(match?.[2]) {
        return parseTriggeredBy(match[2].trim())
      }
      return "Scheduler"
  }

  const CONDITION_OPERATIONS = {
    EQUALS: "==",
    EQUALS_ALT: "eq",
    NOT_EQUALS: "!=",
    NOT_EQUALS_ALT: "neq",
    GREATER_THAN: ">",
    GREATER_THAN_ALT: "gt",
    LESSER_THAN: "<",
    LESSER_THAN_ALT: "lt",
    LESSER_THAN_OR_EQUALS: "=<",
    LESSER_THAN_OR_EQUALS_ALT: "<=",
    LESSER_THAN_OR_EQUALS_ALT_2: "lte",
    GREATER_THAN_OR_EQUALS: ">=",
    GREATER_THAN_OR_EQUALS_ALT: "=>",
    GREATER_THAN_OR_EQUALS_ALT_2: "gte",
    NOT_NULL: "notNull",
    NOT_NULL_ALT: "not_null",
    NOT_NULL_ALT_2: "non_null",
    NOT_NULL_ALT_3: "not null",
    NOT_NULL_ALT_4: "non null",
    NOT_NULL_ALT_5: "notnull",
    NOT_NULL_ALT_6: "nonnull",
    IS_NULL: "isNull",
    IS_NULL_ALT: "is null",
    IS_NULL_ALT_2: "isnull",
    IS_NULL_ALT_3: "is_null",
    ONE_OF: "oneOf",
    ONE_OF_ALT: "one of",
    ONE_OF_ALT_2: "one_of",
    ONE_OF_ALT_3: "oneof",
    INCLUDES: "includes",
    NOT_INCLUDES: "not_includes",
  }

  const shouldShowTaskParam = (param, selectedTask, links = []) => {
    const { conditionParam, conditionOperation, conditionValue } = param

    if(!conditionParam || !conditionOperation) {
      return true;
    }
    const conditionParamObject = (selectedTask?.params || []).find(p => String(p.name).toLowerCase() === String(conditionParam).toLowerCase())
    if(!conditionParamObject) {
      console.warn(`Condition ${conditionParam}${conditionOperation}${conditionValue || ""} is not fullfiled. Condition param ${conditionParam} does not exist.`)
      return false;
    }
    const isConditionParamVisible = shouldShowTaskParam(conditionParamObject, selectedTask, links)
    if(!isConditionParamVisible) {
      return false;
    }
    let conditionParamValue = conditionParamObject?.value
    if(conditionParamObject.dynamic && !conditionParamValue) {
      conditionParamValue = links.find(l => l.input.name === conditionParam || l.output.name === conditionParam)?.value
    }
    switch(String(conditionOperation).toLowerCase()) {
      case CONDITION_OPERATIONS.EQUALS:
      case CONDITION_OPERATIONS.EQUALS_ALT: 
        return conditionParamValue?.toString().toLowerCase() === (ReduxService.nonNullOrUndefined(conditionValue) ? conditionValue :  "")?.toString().toLowerCase()
      case CONDITION_OPERATIONS.NOT_EQUALS:
      case CONDITION_OPERATIONS.NOT_EQUALS_ALT: 
        return conditionParamValue?.toString().toLowerCase() !== (ReduxService.nonNullOrUndefined(conditionValue) ? conditionValue :  "")?.toString().toLowerCase()
      case CONDITION_OPERATIONS.GREATER_THAN:
      case CONDITION_OPERATIONS.GREATER_THAN_ALT:
        return Number(conditionParamValue) > Number(conditionValue) && (conditionParamValue || conditionParamValue === 0)
      case CONDITION_OPERATIONS.LESSER_THAN:
      case CONDITION_OPERATIONS.LESSER_THAN_ALT:
        return Number(conditionParamValue) < Number(conditionValue) && (conditionParamValue || conditionParamValue === 0)
      case CONDITION_OPERATIONS.LESSER_THAN_OR_EQUALS:
      case CONDITION_OPERATIONS.LESSER_THAN_OR_EQUALS_ALT:
      case CONDITION_OPERATIONS.LESSER_THAN_OR_EQUALS_ALT_2:
        return Number(conditionParamValue) <= Number(conditionValue) && (conditionParamValue || conditionParamValue === 0)
      case CONDITION_OPERATIONS.GREATER_THAN_OR_EQUALS:
      case CONDITION_OPERATIONS.GREATER_THAN_OR_EQUALS_ALT:
      case CONDITION_OPERATIONS.GREATER_THAN_OR_EQUALS_ALT_2:
        return Number(conditionParamValue) >= Number(conditionValue) && (conditionParamValue || conditionParamValue === 0)
      case CONDITION_OPERATIONS.NOT_NULL:
      case CONDITION_OPERATIONS.NOT_NULL_ALT:
      case CONDITION_OPERATIONS.NOT_NULL_ALT_2:
      case CONDITION_OPERATIONS.NOT_NULL_ALT_3:
      case CONDITION_OPERATIONS.NOT_NULL_ALT_4:
      case CONDITION_OPERATIONS.NOT_NULL_ALT_5:
      case CONDITION_OPERATIONS.NOT_NULL_ALT_6: {
        return conditionParamValue || conditionParamValue === 0 || conditionParamValue === false
      }
      case CONDITION_OPERATIONS.IS_NULL:
      case CONDITION_OPERATIONS.IS_NULL_ALT:
      case CONDITION_OPERATIONS.IS_NULL_ALT_2:
      case CONDITION_OPERATIONS.IS_NULL_ALT_3:
        return !conditionParamValue && conditionParamValue !== 0 && conditionParamValue !== false
      case CONDITION_OPERATIONS.ONE_OF:
      case CONDITION_OPERATIONS.ONE_OF_ALT:
      case CONDITION_OPERATIONS.ONE_OF_ALT_2: 
      case CONDITION_OPERATIONS.ONE_OF_ALT_3: {
        if(!ReduxService.nonNullOrUndefined(conditionParamValue) || !ReduxService.nonNullOrUndefined(conditionValue)) {
          return false;
        }
        const parsedArray = conditionValue.split(",")
        return parsedArray.findIndex(pa => String(pa).trim().toLowerCase() === String(conditionParamValue).trim().toLowerCase()) > -1
      }
      case CONDITION_OPERATIONS.INCLUDES:
        return conditionValue !== "" && ReduxService.nonNullOrUndefined(conditionValue) && String(conditionValue).trim().toLowerCase().includes(String(conditionParamValue).trim().toLowerCase())
      case CONDITION_OPERATIONS.NOT_INCLUDES:
        return conditionValue !== "" && ReduxService.nonNullOrUndefined(conditionValue) && !String(conditionValue).trim().toLowerCase().includes(String(conditionParamValue).trim().toLowerCase())
      default:
        console.warn(`Condition operation ${conditionOperation} is not supported.`)
        return true;
    }
  }

  const getTaskFromState = nodeId => (_, getState) => {
    const tasks = getState().datascienceState.creatorState.builderState.tasks

    return tasks?.[nodeId]
  }

  return {
    addTask,
    ADD_TASK,
    removeTask,
    REMOVE_TASK,
    SELECT_TASKS,
    selectTasks,
    CONNECT_TASKS,
    connectTasks,
    DISCONNECT_TASKS,
    disconnectTasks,
    addTasks,
    setLinks,
    changePosition,
    CHANGE_POSITION,
    changeTaskProp,
    changeSelectedTaskProp,
    CHANGE_TASK_PROP,
    changeTask,
    CHANGE_TASK,
    changeSelectedTaskParam,
    CHANGE_TASK_PARAM,
    changeMarkdown,
    CHANGE_MARKDOWN,
    setDoubleClickTask,
    DOUBLE_CLICK_TASK,
    addComment,
    ADD_COMMENT,
    setComments,
    SET_COMMENTS,
    changeComment,
    CHANGE_COMMENT,
    REMOVE_COMMENT,
    removeComment,
    setActivePort,
    SET_ACTIVE_PORT,
    clearFooterSelection,
    CLEAR_FOOTER_SELECTION,
    saveTempTitle,
    SAVE_TEMP_TITLE,
    SET_TASK_FOR_REDO,
    addConnections,
    ADD_CONNECTIONS,
    setTaskForRedo,
    play,
    stop,
    undo,
    ON_CHANGE,
    onChange,
    getLastRunBy,
    changeTaskParam,
    shouldShowTaskParam,
    CONDITION_OPERATIONS,
    continuePipeline,
    getTaskFromState,
    CHANGE_POSITIONS,
    changePositions
  };
})();
